import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import dayjs from "dayjs";

interface DateRangeContextProps {
  startDate: string | null;
  endDate: string | null;
  setDateRange: (startDate: string, endDate: string) => void;
}

const DateRangeContext = createContext<DateRangeContextProps>({
  startDate: null,
  endDate: null,
  setDateRange: () => {},
});

export const useDateRangeContext = () => {
  return useContext(DateRangeContext);
};

interface DateRangeProviderProps {
  children: ReactNode;
}

export const DateRangeProvider: React.FC<DateRangeProviderProps> = ({ children }) => {
  const [startDate, setStartDate] = useState<string | null>(
    dayjs().startOf("week").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<string | null>(
    dayjs().endOf("week").subtract(1, "day").format("YYYY-MM-DD")
  );

  const setDateRange = (start: string, end: string) => {
    if (start && end) {
      const startDate = dayjs(start).format("YYYY-MM-DD");
      const endDate = dayjs(end).format("YYYY-MM-DD");
      setStartDate(startDate);
      setEndDate(endDate);
    }
  };

  useEffect(() => {
    if (!startDate || !endDate) {
      setStartDate(dayjs().startOf("week").format("YYYY-MM-DD"));
      setEndDate(dayjs().endOf("week").subtract(1, "day").format("YYYY-MM-DD"));
    }
  }, [startDate, endDate]);

  return (
    <DateRangeContext.Provider value={{ startDate, endDate, setDateRange }}>
      {children}
    </DateRangeContext.Provider>
  );
};

export default DateRangeContext;
